module.exports = __webpack_public_path__ + "img/334.c20ca814.png";